import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytes, FctBytes32 } from '../../../../Fct/generics';
import { FaFileAlt } from 'react-icons/fa';
import { secureStorageAddresses } from '../helpers/constants';
export var Read_fct_bytes = createPlugin({
    protocol: 'SECURE_STORAGE',
    type: 'GETTER',
    method: 'read_fct_bytes',
    supportedContracts: secureStorageAddresses,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    fctMsgHash: new FctBytes32({ isPreview: true }),
                    key: new FctBytes32({ messageType: 'stringOrBytes32', isPreview: true, icon: FaFileAlt }),
                },
            },
            output: {
                value: new FctBytes({ isPreview: true }),
            },
        });
    },
    initParams: {
        methodParams: {
            fctMsgHash: { type: 'global', id: 'flowHash' },
        },
    },
});
